import { Alert, Button, Stack, Typography } from '@mui/material';
import StandalonePage from 'components/standalone-page/standalone-page.component';
import { useLoginLink } from 'hooks/useLoginLink';
import VerifyEmail from 'pages/verify-email/verify-email.component';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectClientName } from 'redux/config/config.selectors';
import ActivationPageForm from './activation-page-form/activation-page-form.component';
import { useVerifyUser } from './activation-page.hooks';

const ActivationPage = () => {
  const { t } = useTranslation();
  const {
    data,
    loading: verifyUserLoading,
    error,
    verifyUser,
  } = useVerifyUser();
  const handleLoginLinkClick = useLoginLink();
  const clientName = useSelector(selectClientName);

  switch (data?.status) {
    case 'INCOMPLETE_PROFILE':
    case 'SOCIAL':
      return (
        <StandalonePage
          title={t('activationPage.title')}
          description={
            data.status === 'SOCIAL'
              ? t('activationPage.description.normal', { clientName })
              : t('activationPage.description.phoneOnly', { clientName })
          }
          data-testid="VerifyEmail.Container"
        >
          <Stack spacing={2} sx={{ width: '100%' }}>
            {data.status === 'SOCIAL' && (
              <Alert severity="info">
                <Stack spacing={1}>
                  <Typography variant="body2">
                    {t('activationPage.social')}
                  </Typography>
                  <Button
                    size="small"
                    variant="contained"
                    onClick={handleLoginLinkClick}
                    sx={{ width: 'fit-content' }}
                    data-testid="LoginLink.Button"
                  >
                    {t('activationPage.loginButton')}
                  </Button>
                </Stack>
              </Alert>
            )}
            <ActivationPageForm data={data.userAccount} status={data.status} />
          </Stack>
        </StandalonePage>
      );
    case 'VERIFIED':
    default:
      return (
        <VerifyEmail
          loading={verifyUserLoading}
          success={data?.status === 'VERIFIED'}
          error={error}
          verifyEmailRequest={verifyUser}
        />
      );
  }
};
export default ActivationPage;
